// extracted by mini-css-extract-plugin
export default {"uploadButton":"UploadButton_uploadButton__TrTY6","uploadInput":"UploadButton_uploadInput__fo1GA"};